import React, {useState} from "react";
import {Link} from "react-router-dom";
import {Button} from "./Button";
import './Navbar.css'
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';

function Navbar() {
    const [click, setClick] = useState(false)
    const [button, setButton] = useState(true)

    const handleClick = () => setClick(!click)
    const closeMobileMenu = () => setClick(false)
    const showButton = () => {
        if(window.innerWidth <= 960) {
            setButton(false)
        } else {
            setButton(true)
        }
    }

    window.addEventListener('resize', showButton)
    return (
        <>
         <nav className="navbar">
             <div className="navbar-container">
                <Link to="/" className="navbar-logo" onClick={closeMobileMenu}>
                    Ekklesia Ministries
                </Link>
                <div className='menu-icon' onClick={handleClick}>
                    {click ? <CloseIcon fontSize="large" style={{ color: 'white'}}/> : <MenuIcon fontSize="large" style={{ color: 'white'}}/> }
                </div>
                 <ul className={click ? 'nav-menu active' : 'nav-menu'}>
                     <li className='nav-item'>
                         <Link to='/' className='nav-links' onClick={closeMobileMenu}>
                             Home
                         </Link>
                     </li>
                     <li className='nav-item'>
                         <Link to='/about-us' className='nav-links' onClick={closeMobileMenu}>
                             About Us
                         </Link>
                     </li>
                     <li className='nav-item'>
                         <Link to='/ministries' className='nav-links' onClick={closeMobileMenu}>
                             Ministries
                         </Link>
                     </li>
                     <li className='nav-item'>
                         <Link to='/media' className='nav-links' onClick={closeMobileMenu}>
                             Media
                         </Link>
                     </li>
                     <li className='nav-item'>
                         <Link to='/resources' className='nav-links' onClick={closeMobileMenu}>
                             Resources
                         </Link>
                     </li>
                     <li className='nav-item'>
                         <Link to='/contact' className='nav-links' onClick={closeMobileMenu}>
                             Contact Us
                         </Link>
                     </li>
                 </ul>
                 {/*{button && <Button buttonStyle='btn--outline'>SIGN UP</Button> }*/}
             </div>
         </nav>
        </>
    )
}

export default Navbar